import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Avatar } from "@faire/web--source/slate/deprecated/Avatar";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var BrandsLandingPageTestimonialTile = function(param) {
    var category = param.category, isMobile = param.isMobile, isPersonalized = param.isPersonalized;
    var isSSR = useIsSSR();
    if (isMobile) {
        return /*#__PURE__*/ _jsxs(Column, {
            style: {
                width: "fit-content"
            },
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    src: optimizeImageUrl({
                        url: category.featureImageUrl
                    }, isSSR, {
                        width: 312,
                        height: 172,
                        resizeMethod: "fill"
                    }),
                    width: 312,
                    height: 172
                }),
                /*#__PURE__*/ _jsx(TestimonialContent, {
                    category: category,
                    isPersonalized: isPersonalized
                })
            ]
        });
    }
    var _category_opacity;
    return /*#__PURE__*/ _jsxs(Row, {
        style: {
            height: "fit-content"
        },
        children: [
            /*#__PURE__*/ _jsx(ContentColumn, {
                $bgColor: isPersonalized ? Core.surface.inverse : category.backgroundColor,
                $opacity: isPersonalized ? undefined : ((_category_opacity = category.opacity) !== null && _category_opacity !== void 0 ? _category_opacity : 0) / 2,
                justify: "center",
                children: /*#__PURE__*/ _jsx("img", {
                    src: optimizeImageUrl({
                        url: category.featureImageUrl
                    }, isSSR)
                })
            }),
            /*#__PURE__*/ _jsx(TestimonialContent, {
                category: category,
                isPersonalized: isPersonalized
            })
        ]
    });
};
var TestimonialContent = function(param) {
    var category = param.category, isPersonalized = param.isPersonalized;
    var _category_internationalTestimonialData, _category_internationalTestimonialData1, _category_internationalTestimonialData2, _category_internationalTestimonialData3, _category_internationalTestimonialData4, _category_internationalTestimonialData5, _category_internationalTestimonialData6;
    var isSSR = useIsSSR();
    var isInternational = RetailerStore.get().isInternational && isNotUndefined(category.internationalTestimonialData);
    var brandLogoUrl = isInternational && ((_category_internationalTestimonialData = category.internationalTestimonialData) === null || _category_internationalTestimonialData === void 0 ? void 0 : _category_internationalTestimonialData.logoUrl) ? category.internationalTestimonialData.logoUrl : category.brandLogoUrl;
    return /*#__PURE__*/ _jsxs(TestimonialContentWrapper, {
        justify: "space-between",
        $bgColor: isPersonalized ? Core.surface.inverse : category.backgroundColor,
        $opacity: isPersonalized ? undefined : category.opacity,
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                children: [
                    isInternational && ((_category_internationalTestimonialData1 = category.internationalTestimonialData) === null || _category_internationalTestimonialData1 === void 0 ? void 0 : _category_internationalTestimonialData1.brandName) && !category.internationalTestimonialData.logoUrl ? /*#__PURE__*/ _jsx(Typography, {
                        variant: "pageHeaderSerifRegular",
                        children: (_category_internationalTestimonialData2 = category.internationalTestimonialData) === null || _category_internationalTestimonialData2 === void 0 ? void 0 : _category_internationalTestimonialData2.brandName
                    }) : /*#__PURE__*/ _jsx("img", {
                        style: {
                            width: "fit-content"
                        },
                        src: optimizeImageUrl({
                            url: brandLogoUrl
                        }, isSSR)
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subheadingSansRegular",
                        children: isInternational ? (_category_internationalTestimonialData3 = category.internationalTestimonialData) === null || _category_internationalTestimonialData3 === void 0 ? void 0 : _category_internationalTestimonialData3.testimonial : category.testimonial
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(Column, {
                children: /*#__PURE__*/ _jsxs(Row, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Avatar, {
                            size: "small",
                            src: isInternational ? (_category_internationalTestimonialData4 = category.internationalTestimonialData) === null || _category_internationalTestimonialData4 === void 0 ? void 0 : _category_internationalTestimonialData4.profileImageUrl : category.profileImageUrl
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: "2x"
                        }),
                        /*#__PURE__*/ _jsxs(Column, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraphSansMedium",
                                    children: isInternational ? (_category_internationalTestimonialData5 = category.internationalTestimonialData) === null || _category_internationalTestimonialData5 === void 0 ? void 0 : _category_internationalTestimonialData5.brandOwnerName : category.brandOwnerName
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: isInternational ? (_category_internationalTestimonialData6 = category.internationalTestimonialData) === null || _category_internationalTestimonialData6 === void 0 ? void 0 : _category_internationalTestimonialData6.nameSubtitle : category.brandOwnerNameSubtitle
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var ContentColumn = styled(Column).attrs({
    flex: 1
}).withConfig({
    componentId: "sc-be32bb76-0"
})([
    "background-color:",
    "",
    ";width:312px;",
    "{width:410px;}transition:background-color 0.3s ease-in-out;"
], function(props) {
    return props.$bgColor;
}, function(props) {
    return props.$opacity;
}, responsiveMediaQueries.tabletAndAbove);
var TestimonialContentWrapper = styled(ContentColumn).withConfig({
    componentId: "sc-be32bb76-1"
})([
    "padding:",
    ";"
], getSpacing("5x"));
var Image = styled.img.withConfig({
    componentId: "sc-be32bb76-2"
})([
    "width:",
    "px;height:",
    "px;"
], function(props) {
    return props.width;
}, function(props) {
    return props.height;
});
